<script lang="ts">
  /* INFO
    this component accepts a list of links for now.
    Once the breadcrumbs pattern is confirmed we can map the url path to the breadcrumbs
    it could be refactored to automatically separate each url path
  */
  import ChevronUp from '../../../assets/svgs/chevron-up.svelte';

  type BreadcrumLink = {
    href: string;
    label: string;
    isCurrentUrl?: boolean;
  };

  export let links: BreadcrumLink[] = [];
  export let currentTextColor: string = 'text-gray-700';
  export let textColor: string = 'text-gray-500';
  export let chevronColor: string = '#667085';
  export let customClass: string = '';
</script>

<ul class="list-none flex flex-row self-center lg:self-start flex-wrap {customClass}">
  {#if links.length}
    {#each links as link, index}
      <li
        class="flex flex-row items-center text-sm capitalize text-left md:text-center {link?.isCurrentUrl
          ? `${currentTextColor} font-semibold`
          : `${textColor} font-normal`} "
      >
        <a href={link?.href}>{link?.label}</a>
        {#if index !== links.length - 1}
          <ChevronUp customClass="rotate-90 mx-2" color={chevronColor} />
        {/if}
      </li>
    {/each}
  {/if}
</ul>
